import { render, staticRenderFns } from "./ModalSuporteHospital.vue?vue&type=template&id=1fc8710e&scoped=true"
import script from "./ModalSuporteHospital.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteHospital.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteHospital.vue?vue&type=style&index=0&id=1fc8710e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8710e",
  null
  
)

export default component.exports